<template>
  <analytics-sub-page
    title="Rewards Analytics"
    icon="gift"
    css-class="analytics-rewards"
    default-label="Rewards"
    :section-specs="sectionSpecs"
  >
    <rewards-metrics ref="rewardsRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import RewardsMetrics from '@/pages/analyticsApp/components/RewardsMetrics.vue';

const rewardsRef = ref(null);

// RewardsMetrics renders two logical subsections: the counter-card "Activity"
// row and the "Trending brands" panel. Trending brands are drawn from
// getPdfData (not DOM charts), so that extra is scoped to the trending spec
// only and won't repeat on the activity sheet.
const sectionSpecs = [
  {
    key: 'activity',
    label: 'Activity',
    hasData: () => !!rewardsRef.value?.hasActivityData,
    getContainerEl: () =>
      rewardsRef.value?.$el?.querySelector('[data-pdf-section="activity"]') || rewardsRef.value?.$el,
    getExportTable: () => rewardsRef.value?.getExportTable?.() ?? null,
  },
  {
    key: 'trending',
    label: 'Trending brands',
    hasData: () => !!rewardsRef.value?.hasTrendingData,
    getContainerEl: () =>
      rewardsRef.value?.$el?.querySelector('[data-pdf-section="trending"]') || rewardsRef.value?.$el,
    getExportTable: () => rewardsRef.value?.getTrendingExportTable?.() ?? null,
    getPdfData: () => rewardsRef.value?.getTrendingPdfData?.() ?? {},
  },
];
</script>
